// React
import React, { useCallback, useContext, useEffect, useState } from "react";
// React

// CSS
import styles from "./TimeLine.module.css";
// CSS

import { BsPlay, BsPause } from "react-icons/bs";
import { FaVolumeMute } from "react-icons/fa";
import { AiOutlineSound } from "react-icons/ai";
import { TiMediaFastForward, TiMediaRewind } from "react-icons/ti";
import { SlSizeFullscreen } from "react-icons/sl";
import { fullScreenHandler } from "../Mobile/Mobile";
import { PlaySpeedContext } from "../../TeachItemVideoShower";

type TimeLineProps = {
  videoTime: string | number;
  videoRef: React.RefObject<HTMLVideoElement>;
  currentTime: string | number;
  containerRef: React.RefObject<HTMLDivElement>;
  x: number;
};

const TimeLine: React.FunctionComponent<TimeLineProps> = ({
  currentTime,
  videoRef,
  videoTime,
  containerRef,
  x,
}) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState<boolean>(
    videoRef.current?.paused!
  );
  const [currVideoTime, setCurrVideoTime] = useState<string | number>(
    currentTime || 0
  );
  const [isVideoMuted, setIsVideoMuted] = useState<boolean>(false);

  const playSpeed = useContext(PlaySpeedContext);

  const seekVideo = useCallback(
    (currVideoTime: number) => {
      if (!videoRef.current) return;
      videoRef.current.currentTime = Number(currVideoTime);
    },
    [videoRef]
  );

  const seekNext5Sec = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      Number(currentTime) + 5 > Number(videoTime)
        ? setCurrVideoTime(Number(currentTime))
        : setCurrVideoTime((prevState) => {
            seekVideo(Number(prevState) + 5);
            return Number(prevState) + 5;
          });
    },
    [videoTime, currentTime, seekVideo]
  );
  const seekPrev5Sec = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      Number(videoTime) <= 4
        ? setCurrVideoTime((prevState) => prevState)
        : setCurrVideoTime((prevState) => {
            seekVideo(Number(prevState) - 5);
            return Number(prevState) - 5;
          });
    },
    [videoTime, seekVideo]
  );

  useEffect(() => {
    if (!videoRef.current) return;

    if (isVideoPlaying) {
      videoRef.current.pause();
      return;
    } else {
      videoRef.current.play();
    }
  }, [isVideoPlaying, videoRef]);

  useEffect(() => {
    if (!videoRef.current) return;

    videoRef.current.muted = isVideoMuted;
  }, [videoRef, isVideoMuted]);

  useEffect(() => {
    setCurrVideoTime(x);
  }, [x]);

  useEffect(() => {
    if (!videoRef.current) return;
    videoRef.current.playbackRate = playSpeed / 100;
  }, [videoRef, playSpeed]);

  return (
    <div
      className={`${styles.timeLine}`}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        className={`flex flex-row items-center justify-start ${
          window.innerWidth > 1000 ? "w-[75%]" : "w-[60%]"
        }`}
      >
        {isVideoPlaying ? (
          <BsPlay
            onClick={() => {
              setIsVideoPlaying((prevState) => !prevState);
            }}
          />
        ) : (
          <BsPause
            onClick={() => {
              setIsVideoPlaying((prevState) => !prevState);
            }}
          />
        )}

        <p
          className="flex flex-row items-center justify-center  "
          onClick={(e) => {
            e.stopPropagation();
          }}
          onDoubleClick={(e) => {
            e.stopPropagation();
          }}
        >
          <TiMediaRewind onClick={seekPrev5Sec} className="!text-white" />

          <TiMediaFastForward onClick={seekNext5Sec} className="!text-white" />
        </p>
        <input
          type="range"
          step={1}
          min={0}
          max={videoTime}
          value={currVideoTime}
          onChange={(e) => {
            setCurrVideoTime(e.target.value);
            seekVideo(Number(e.target.value));
          }}
        />
      </div>
      <div className="flex flex-row items-center justify-center ">
        <p className="text-white text-xs flex flex-row items-center justify-center mr-2 lg:mr-0">
          {(() => {
            const currTime = x;

            const currMin = parseInt(String(Math.floor(currTime / 60)));

            const maxTime = Number(videoTime);

            const maxMin =
              String(parseInt(String(Math.floor(maxTime / 60)))).length === 1
                ? `0${parseInt(String(Math.floor(maxTime / 60)))}`
                : parseInt(String(Math.floor(maxTime / 60)));

            const maxSec =
              String(parseInt(String(maxTime / 60 - 1 * 60))).length === 1
                ? `0${parseInt(String(maxTime / 60 - 1 * 60))}`
                : parseInt(String(maxTime / 60 - 1 * 60));

            const currSec =
              String(parseInt(String(currTime % 60))).length === 1
                ? `0${parseInt(String(currTime % 60))}`
                : parseInt(String(currTime % 60));

            console.log({
              currMin,
              currSec,
              maxMin,
              maxSec,
            });

            return (
              <>
                {Math.abs(currMin)}
                {<>&nbsp;</>}:{<>&nbsp;</>}
                {Math.abs(Number(currSec))}
                {<>&nbsp;</>}-{<>&nbsp;</>}
                {Math.abs(Number(maxMin))}
                {<>&nbsp;</>}:{<>&nbsp;</>}
                {Math.abs(Number(maxSec))}
              </>
            );
          })()}
        </p>
        {isVideoMuted ? (
          <FaVolumeMute
            onClick={() => {
              setIsVideoMuted((prevState) => !prevState);
            }}
          />
        ) : (
          <AiOutlineSound
            onClick={() => {
              setIsVideoMuted((prevState) => !prevState);
            }}
          />
        )}
        <SlSizeFullscreen
          onClick={() => {
            fullScreenHandler(containerRef, "fafaf", () => {});
          }}
        />
      </div>
    </div>
  );
};

export default TimeLine;
